import { Switch } from 'antd';
import React from "react";

function onChange(checked) {
    
  }

function OnAndOffSwitch(){
    return(
        <Switch defaultChecked onChange={onChange}/>
    )
}





export default OnAndOffSwitch;